var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccelerationDistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_3071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7666 1.89147C19.3504 2.93534 20.6503 4.35599 21.5496 6.02599L19.7497 6.92106C18.9685 5.29141 18.1801 4.43033 16.7526 3.39494C15.324 2.35875 14.2902 2.0832 12.5212 1.80817C10.6053 1.51029 9.35139 1.5908 7.58464 2.33709C6.3421 2.86196 5.38564 3.2964 4.2348 4.27648C2.40563 5.83423 1.54235 7.0862 0.884977 9.43679C0.29686 11.5397 0.486568 12.9003 0.988631 15.0272C1.47236 17.0766 2.46402 18.7197 3.56305 19.7647C2.18848 18.4577 1.15983 16.8298 0.569383 15.0272C-0.0210693 13.2247 -0.154864 11.3038 0.18 9.43679C0.514865 7.56977 1.30791 5.81507 2.48802 4.33008C3.66812 2.84509 5.19837 1.67624 6.94151 0.928368C8.68465 0.180498 10.5862 -0.123002 12.4755 0.0450913C14.3648 0.213185 16.1829 0.847614 17.7666 1.89147Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3535 7.67761C23.1562 9.71359 23.0879 11.6138 22.8637 13.4973L20.8763 13.195C21.1739 11.4124 21.0239 10.2546 20.4511 8.58673L22.3535 7.67761Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7173 13.5511C10.7044 13.5516 9.88295 12.7308 9.88251 11.7179C9.88206 10.7051 10.7028 9.88362 11.7157 9.88318C12.7285 9.88273 13.55 10.7035 13.5504 11.7163C13.5509 12.7292 12.7301 13.5507 11.7173 13.5511ZM11.716 10.5801C11.088 10.5804 10.5791 11.0897 10.5794 11.7176C10.5797 12.3456 11.089 12.8545 11.717 12.8542C12.3449 12.8539 12.8538 12.3446 12.8535 11.7166C12.8533 11.0887 12.3439 10.5798 11.716 10.5801Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2116 6.63562L13.4402 11.9228L12.593 10.1532L22.2116 6.63562Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9798 13.2856L9.67022 13.9126C9.57887 13.9563 9.46935 13.9178 9.4256 13.8264L8.60033 12.1027C8.55659 12.0113 8.59519 11.9018 8.68655 11.8581L9.9961 11.2311L10.9798 13.2856Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_3071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.7647,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerationDistance);
export default __webpack_public_path__ + "static/media/acceleration-distance.1b2ac3fc4a288477d5567bc7909233d1.svg";
export { ForwardRef as ReactComponent };